import { StatementPayloadBuilder } from "../statements";
import {
  ILrsClient,
  LrsCredentials,
  LrsEnvironment,
  StatementParams,
  StatementPayload,
} from "../types";
import { sendStatement } from "../utils";
export * from "../types";

export class LrsClient implements ILrsClient {
  private env: LrsEnvironment;
  private credentials: LrsCredentials;
  private platform: string;
  private homepage: string;

  constructor(
    env: LrsEnvironment,
    platform: string,
    homepage: string,
    credentials: LrsCredentials,
  ) {
    this.env = env;
    this.platform = platform;
    this.homepage = homepage;
    this.credentials = credentials;
  }

  public send(
    arg: StatementParams | StatementParams[],
    isBeacon = false,
  ): void {
    let payload: StatementPayload | StatementPayload[];

    if (arg instanceof Array) {
      payload = arg.map((statement) => {
        return new StatementPayloadBuilder()
          .setVerb(statement.verb)
          .setContext(this.platform, statement.context)
          .setObject(statement.object)
          .setActor(this.homepage, statement.actor)
          .setAuthority(statement.authority)
          .setResult(statement.result)
          .build();
      });
    } else {
      payload = new StatementPayloadBuilder()
        .setVerb(arg.verb)
        .setContext(this.platform, arg.context)
        .setObject(arg.object)
        .setActor(this.homepage, arg.actor)
        .setAuthority(arg.authority)
        .setResult(arg.result)
        .build();
      payload = [payload];
    }

    sendStatement(this.credentials, this.env, payload, isBeacon);
  }
}
